import { useUser as useUserContext } from '../context/UserContext.tsx';

// Maintaining the legacy hook structure for backward compatibility
export const useUser = () => {
  const { user, loading, error, refreshUser } = useUserContext();
  
  return {
    data: user,
    isLoading: loading,
    error,
    refreshUser
  };
};
